const ANALYTICS_CONSENT_KEY = "@robotical/appv2-analytics-consent";

export const checkAnalyticsConsent = async (): Promise<boolean | undefined> => {
    const analyticsConsent = await window.applicationManager.loadFileFromDeviceLocalStorage("", ANALYTICS_CONSENT_KEY);
    let consent;
    if (analyticsConsent === "true") {
        consent = true;
    } else if (analyticsConsent === "false") {
        consent = false;
    } else {
        consent = undefined;
    }
    return consent;
};

export const setAnalyticsConsentWithoutTracking = async (consent: boolean) => {
    window.applicationManager.AnalyticsFacade.consent = consent; // TODO: use setConsentWithoutTracking in the future when available
    await window.applicationManager.saveFileOnDeviceLocalStorage("", ANALYTICS_CONSENT_KEY, consent.toString());
}

export const setAnalyticsConsentWithTracking = async (consent: boolean) => {
    window.applicationManager.AnalyticsFacade.setConsent(consent);
    await window.applicationManager.saveFileOnDeviceLocalStorage("", ANALYTICS_CONSENT_KEY, consent.toString());
}